import CoursesContent from "../../components/others/courses/CoursesContent";
import {Helmet} from "react-helmet";
import {buildHelmetTitle} from "../../helpers/SeoHelper";
import SystemAppScreenLayout from "../../components/layouts/SystemAppScreenLayout";
import SystemAppContentLayout from "../../components/layouts/SystemAppContentLayout";

export default function CoursesScreen({ selectedGrade,
                                        setFlashGrade,
                                        fetchQuestionsCallback,
                                        fetchExerciserProblemCallback }) {
    // Used in MetaCoursesScreen for the user to select LevelAs through
    // Subthemes

    // BUILD
    return (
        <div className={"grow w-full h-[100svh] flex justify-start items-center"}>
        {/** META */}
            <Helmet>
                <title>{buildHelmetTitle('Ummia - Cours et exercices')}</title>
                <meta name="description"
                      content="Explications et exercices pour maitriser chaque savoir-faire fondamental du collège." />
            </Helmet>
            {/** CONTENT */}
            <SystemAppScreenLayout>
                <SystemAppContentLayout>
                    <CoursesContent setFlashGrade={setFlashGrade}
                                      selectedGrade={selectedGrade}
                                      fetchQuestionsCallback={fetchQuestionsCallback}
                                      fetchExerciserProblemCallback={fetchExerciserProblemCallback} />
                </SystemAppContentLayout>
            </SystemAppScreenLayout>
        </div>
    );
}
